"use client";

import { ButtonNova } from "@/components/ui-kit/ButtonNova/ButtonNova";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { cn } from "@/utils/general";

import styles from "./HomepageHero.module.scss";
import { HomepageHeroButton } from "./HomepageHero.types";

type HomepageHeroBenefitsProps = {
  items: string[];
  shop: HomepageHeroButton;
};

const HomepageHeroBenefits = ({ items, shop }: HomepageHeroBenefitsProps) => (
  <div className={cn(styles.mxLg, "max-w-[327px] md:max-w-[527px] xl:max-w-[800px]")}>
    <div className="flex flex-col items-center xl:items-start relative xl:min-h-[175px]">
      {items.map((item) => (
        <div
          key={item}
          className="flex w-full items-center text-center xl:text-left [&:not(:last-of-type)]:pb-4"
        >
          <TextElementNova
            text={item}
            element="p"
            classes={{
              default: "Body-20-Dia-Normal",
              768: "Body-30-Dia-Normal",
              1280: "Body-30-Dia-Normal",
            }}
          />
        </div>
      ))}
    </div>
    <div
      className={cn(
        styles.mxLg,
        "w-[133px] md:w-[125px] lg:w-[146px] pt-8 md:pt-10 pb-10 md:pb-12 xl:pb-0"
      )}
    >
      <ButtonNova
        icon="Right"
        label="Shop Now"
        className="lifestage-cta"
        ctaLink={shop.ctaLink}
        trackObject={{
          destination: shop.ctaLink,
          name: "Marketing CTA Clicked",
          module_name: "lifestage",
          type: "button",
        }}
      />
    </div>
  </div>
);

export default HomepageHeroBenefits;
